import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ProcessingStatusModel } from '../../../../../client/model/processing-status-model';
import { StationGroup, StationGroupType } from '../../model/yard-structure.model';


@Component({
  selector: 'app-stationgroup-details',
  templateUrl: './stationgroup-details.component.html',
  styleUrls: ['./stationgroup-details.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class StationGroupDetailsComponent implements OnInit {
  @Input() stationGroup: StationGroup = new StationGroup();

  stationGroupTypes: StationGroupType[] = [];

  processingStatusModels: ProcessingStatusModel[] = [];

  constructor(

  ) {

    for (const k of Object.keys(StationGroupType)) {
      this.stationGroupTypes.push(StationGroupType[k]);
    }

  }

  ngOnInit() {

  }
}
